"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GoCardless = void 0;
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../../../../shared/core");
var copy_1 = require("../../../../../../copy");
var GoCardless = function () {
    var Margin = (0, core_1.useComponents)().Margin;
    var Copy = (0, core_1.useCopy)(copy_1.defaultOptions).Copy;
    return (react_1.default.createElement(Margin, { top: 6 },
        react_1.default.createElement("div", { "data-testid": "goCardless" },
            react_1.default.createElement(Copy, { copyKey: "setupDirectDebitGoCardless" }))));
};
exports.GoCardless = GoCardless;
